export default __webpack_public_path__ + "static/media/Inter-UI-SemiBold.0be464de.woff";